import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "./index";

export const AI_addPartyOrder = apiBase.createInstance({
  endpoint: "/party",
  method: "post",
  reducer: "partyOrderReducer",
  reduxKey: "addPartyOrder",
  action: "SEND_PARTY_ORDER",
  middleware: notificationMiddleWare,
});

export const AI_getItem = apiBase.createInstance({
  endpoint: "/get-party",
  method: "get",
  reducer: "partyOrderReducer",
  reduxKey: "getPartyItem",
  action: "GET_PARTY_ITEM",
  onSuccess: (data) => data,
});

export const AI_closeResponce = apiBase.createInstance({
  endpoint: "/close-party",
  method: "post",
  reducer: "partyOrderReducer",
  reduxKey: "closeResponce",
  action: "CLOSE_PARTY_RESPONCE",
  middleware: notificationMiddleWare,
});

export const AI_partyResponse = apiBase.createInstance({
  endpoint: "/response-party",
  method: "post",
  reducer: "partyOrderReducer",
  reduxKey: "responseParty",
  action: "RESPONSE_PARTY",
  middleware: notificationMiddleWare,
});

export const AI_findParty = apiBase.createInstance({
  endpoint: "/find-party",
  method: "get",
  reducer: "partyOrderReducer",
  reduxKey: "findPartAvailable",
  action: "FIND_PARTY_AVAILABLE",
  onSuccess: (data) => data.data,
});

export const AI_showEmployee = apiBase.createInstance({
  endpoint: "/show-employee_list",
  method: "get",
  reducer: "partyOrderReducer",
  reduxKey: "showEmployee",
  action: "SHOW_EMPLOYEE_LIST",
  onSuccess: (data) => data,
});
